import { FlowGraphBlock } from "../../flowGraphBlock.js";
import { RichTypeString, RichTypeAny } from "../../flowGraphRichTypes.js";
/**
 * A block that gets the value of a variable.
 * @experimental
 */
export class FlowGraphGetVariableBlock extends FlowGraphBlock {
    /**
     * Construct a FlowGraphGetVariableBlock.
     * @param params optional construction parameters
     */
    constructor(params) {
        super();
        this.variableName = this._registerDataInput("variableName", RichTypeString);
        if (params === null || params === void 0 ? void 0 : params.variableName) {
            this.variableName.value = params.variableName;
        }
        this.output = this._registerDataOutput("output", RichTypeAny);
    }
    /**
     * @internal
     */
    _updateOutputs(context) {
        const variableNameValue = this.variableName.getValue(context);
        if (context.hasVariable(variableNameValue)) {
            this.output.value = context.getVariable(variableNameValue);
        }
    }
}
//# sourceMappingURL=flowGraphGetVariableBlock.js.map